import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { IconButtonComponent } from '../../../../popper/components/icon-button/icon-button.component';
import { IconButtonColorEnumPipe } from '../../../../popper/components/icon-button/icon-button-color-enum.pipe';
import { ButtonComponent, ButtonShapeEnumPipe, ButtonColorEnumPipe, ButtonSizeEnumPipe } from 'ui-library-shared';

@Component({
    selector: 'app-open-rollback-cell',
    templateUrl: './open-rollback-cell.component.html',
    styleUrls: ['./open-rollback-cell.component.scss'],
    standalone: true,
  imports: [IconButtonComponent, IconButtonColorEnumPipe, ButtonComponent, ButtonSizeEnumPipe, ButtonShapeEnumPipe, ButtonColorEnumPipe]
})
export class OpenRollbackCellComponent implements OnInit, ICellRendererAngularComp {
  public data: any;
  public api: any;
  public rowIndex: number = -1;
  public readOnly: boolean = true;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    this.rowIndex = params.node.rowIndex;
    return false;
  }

  agInit(params: ICellRendererParams<any, any>): void {
    this.data = params.data;
    this.api = params.api;
    this.rowIndex = params.node.rowIndex;
  }

  open(): void {
    this.router.navigate(['/disclosure/edit-disclosure/', this.data.disclosureId]);
  }

  rollback() {
    if (this.api.onActionTrigger) {
      this.api.onActionTrigger({ row: this.rowIndex, action: "rollback", data: this.data });
    } else {
      console.error("OnActionTrigger not defined");
    }
  }

}
